import React, { useEffect, useState } from "react";
import { useHistory } from "react-router-dom";
import CustomCard from "../../shared/Card/CustomCard";
import { useDispatch, useSelector } from "react-redux";
import { getKeyList, getrevealkey } from "../../redux/actions/profileAction";
import TableCard from "../../shared/TableCard/TableCard";
import { DataTable } from "primereact/datatable";
import { Column } from "primereact/column";
import CustomDialog from "../../shared/Dailog/CustomDailog";

const SecretKeys = () => {
  const dispatch = useDispatch();
  const history = useHistory();

  const keys = useSelector((state) =>
    Array.isArray(state?.profile?.keyList) ? state.profile.keyList : [],
  );
  const [dialogVisible, setDialogVisible] = useState(false);
  const [revealedKey, setRevealedKey] = useState("");

  useEffect(() => {
    dispatch(getKeyList());
  }, [dispatch]);

  const handleViewAction = async (rowData) => {
    const revealParam = rowData?.key;
    const res = await dispatch(getrevealkey(revealParam));
    if (!res?.success) {
      return;
    }
    const revealedValue = res?.data?.key ?? rowData?.key ?? "-";

    setRevealedKey(revealedValue);
    setDialogVisible(true);
  };

  const handleEditAction = (rowData) => {
    if (!rowData) {
      return;
    }

    history.push({
      pathname: "/settings/secrets/add",
      state: { editData: rowData },
    });
  };

  const keyTemplate = () => {
    return <span>**************************</span>;
  };

  const viewKeyTemplate = (rowData) => {
    return (
      <div className="flex align-items-center">
        {rowData?.key ? (
          <i
            className="pi pi-eye cursor-pointer ml-2"
            onClick={() => handleViewAction(rowData)}
          ></i>
        ) : null}
        <i
          className="pi pi-pencil cursor-pointer ml-4"
          onClick={() => handleEditAction(rowData)}
        ></i>
      </div>
    );
  };

  return (
    <div>
      <CustomCard>
        <TableCard
          title="Secret Key"
          buttonTitle="Add Secret Key"
          linkTo="/settings/secrets/add"
        >
          <DataTable
            paginator
            value={keys}
            className=""
            showGridlines
            rows={10}
            emptyMessage="No Secret Keys found."
          >
            <Column
              field="name"
              header="Name"
              style={{ width: "250px" }}
            ></Column>
            <Column
              field="key"
              header="Key"
              body={keyTemplate}
              style={{ width: "250px" }}
            ></Column>
            <Column
              field="description"
              header="Description"
              style={{ width: "250px" }}
            ></Column>
            <Column
              field="action"
              header="Action"
              body={viewKeyTemplate}
              style={{ width: "250px" }}
            ></Column>
          </DataTable>
        </TableCard>
      </CustomCard>
      <CustomDialog
        visible={dialogVisible}
        setVisible={setDialogVisible}
        onHide={() => {
          setDialogVisible(false);
          setRevealedKey("");
        }}
        classNames="secret-key-dialog"
      >
        <div className="text-center">
          <h1 className="text-4xl">Secret Key</h1>
          <p className="text-Black break-all select-all">{revealedKey}</p>
        </div>
      </CustomDialog>
    </div>
  );
};

export default SecretKeys;
